/**
 * @file コンポーネント：スライダー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledSlider,
    StyledSliderArrow,
    StyledSliderArrowInactive,
    StyledSliderArrowlist,
    StyledSliderArrowlistItemLeft,
    StyledSliderArrowlistItemRight,
    StyledSliderClose,
    StyledSliderContainer,
    StyledSliderContentlist,
    StyledSliderContentlistItem,
    StyledSliderDot,
    StyledSliderDotInactive,
    StyledSliderDotlist,
    StyledSliderDotlistItem,
    StyledSliderZoom,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledSlider
            className={[
                props.sliderCover === true && "is-covered",
                props.isZoom === true && "is-open",
            ]}
        >
            {props.zoom && props.list.length > 0 && (
                // ズーム機能がtrueかつスライドが1枚以上ある場合
                <>
                    {props.isZoom === true ? (
                        // 拡大表示中
                        <StyledSliderClose
                            onClick={() => props.setIsZoom(!props.isZoom)}
                            title={localized["Label.ZoomOutContent"]}
                        >
                            <i className="fas fa-times"></i>
                        </StyledSliderClose>
                    ) : (
                        // 通常表示中
                        <StyledSliderZoom
                            onClick={() => props.setIsZoom(!props.isZoom)}
                            title={localized["Label.ZoomInContent"]}
                        >
                            <i className="fas fa-search-plus"></i>
                        </StyledSliderZoom>
                    )}
                </>
            )}
            <StyledSliderContainer>
                <StyledSliderContentlist>
                    {props.list.map((item, index) => (
                        <StyledSliderContentlistItem
                            className={
                                index === props.currentIndex && "is-current"
                            }
                            key={"slide-" + index}
                        >
                            {item}
                        </StyledSliderContentlistItem>
                    ))}
                </StyledSliderContentlist>
                {props.arrows && props.list.length > 1 && (
                    // アロー表示状態がtrueかつ2枚以上スライドがある場合
                    <StyledSliderArrowlist>
                        <StyledSliderArrowlistItemLeft>
                            {props.currentIndex === 0 ? (
                                // 最初のスライドがカレント表示
                                <StyledSliderArrowInactive>
                                    <i className="fas fa-chevron-left"></i>
                                </StyledSliderArrowInactive>
                            ) : (
                                // それ以外
                                <StyledSliderArrow
                                    onClick={() =>
                                        props.setCurrentIndex(
                                            props.currentIndex - 1
                                        )
                                    }
                                    title={localized["Label.Previous"]}
                                >
                                    <i className="fas fa-chevron-left"></i>
                                </StyledSliderArrow>
                            )}
                        </StyledSliderArrowlistItemLeft>
                        <StyledSliderArrowlistItemRight>
                            {props.currentIndex === props.list.length - 1 ? (
                                // 最後のスライドがカレント表示
                                <StyledSliderArrowInactive>
                                    <i className="fas fa-chevron-right"></i>
                                </StyledSliderArrowInactive>
                            ) : (
                                // それ以外
                                <StyledSliderArrow
                                    onClick={() =>
                                        props.setCurrentIndex(
                                            props.currentIndex + 1
                                        )
                                    }
                                    title={localized["Label.Next"]}
                                >
                                    <i className="fas fa-chevron-right"></i>
                                </StyledSliderArrow>
                            )}
                        </StyledSliderArrowlistItemRight>
                    </StyledSliderArrowlist>
                )}
            </StyledSliderContainer>
            {props.dots && props.list.length > 1 && (
                // ドット表示状態がtrueかつ2枚以上スライドがある場合
                <StyledSliderDotlist>
                    {props.list.map((_, index) => (
                        <StyledSliderDotlistItem key={"dot-" + index}>
                            {props.currentIndex === index ? (
                                // カレント表示のドット
                                <StyledSliderDotInactive />
                            ) : (
                                // 非カレント表示のドット
                                <StyledSliderDot
                                    onClick={() => props.setCurrentIndex(index)}
                                />
                            )}
                        </StyledSliderDotlistItem>
                    ))}
                </StyledSliderDotlist>
            )}
        </StyledSlider>
    );
};
